// src/pages/Contact.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/apiBase';
import GradientButton from '../components/GradientButton';

const Contact = () => {
  const [form, setForm] = useState({ name:'', email:'', subject:'', message:'' });
  const [status, setStatus] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('');
    setIsSubmitting(true);
    
    try {
      console.log('📧 Submitting contact form:', form);
      
      // Updated to use your Cloud Function URL
      const res = await fetch(apiUrl('contactForm'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      
      const data = await res.json();
      console.log('📧 Contact form response:', data);
      
      if (res.ok && data.success) {
        setSubmitted(true);
        setStatus('✅ Message sent successfully! We\'ll be in touch soon.');
        setForm({ name:'', email:'', subject:'', message:'' });
      } else {
        setStatus(`❌ ${data.error || 'Failed to send message. Please try again.'}`);
      }
    } catch (error) {
      console.error('❌ Contact form error:', error);
      setStatus('❌ Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      const t = setTimeout(() => navigate('/'), 5000);
      return () => clearTimeout(t);
    }
  }, [submitted, navigate]);

  return (
    <>
      {/* green sub‑bar */}
      <div
        style={{
          backgroundColor: '#A6CE3A',
          height: '25px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <h2
          style={{
            margin: 0,
            color: '#FFF',
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 'bold',
            fontSize: '1.25rem'
          }}
        >
          Contact Us
        </h2>
      </div>

      <div style={{ 
        maxWidth:'600px', 
        margin:'2rem auto', 
        padding:'2rem', 
        background:'#fff', 
        borderRadius:'6px', 
        boxShadow:'0 0 10px rgba(0,0,0,0.05)', 
        fontFamily: "'Open Sans', sans-serif" 
      }}>
        {submitted ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h3 style={{ color: '#27AE60', marginBottom: '1rem' }}>Thank You!</h3>
            <p style={{ color: '#27AE60', fontSize: '1.1rem' }}>{status}</p>
            <p style={{ color: '#666', marginTop: '1rem' }}>
              Redirecting to home page in a few seconds...
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
            <input 
              name="name"    
              placeholder="Your Name"    
              value={form.name}    
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
              style={{...inputStyle, opacity: isSubmitting ? 0.7 : 1}} 
            />
            <input 
              name="email"   
              type="email"
              placeholder="Your Email"   
              value={form.email}   
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
              style={{...inputStyle, opacity: isSubmitting ? 0.7 : 1}} 
            />
            <input 
              name="subject" 
              placeholder="Subject"      
              value={form.subject} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
              style={{...inputStyle, opacity: isSubmitting ? 0.7 : 1}} 
            />
            <textarea 
              name="message" 
              placeholder="Your message..."  
              value={form.message} 
              onChange={handleChange} 
              required 
              rows={6} 
              disabled={isSubmitting}
              style={{...textareaStyle, opacity: isSubmitting ? 0.7 : 1}} 
            />
            <GradientButton
  variant="emerald"
  type="submit"
  disabled={isSubmitting}
  style={{
    padding: '1rem 2rem',
    fontSize: 'clamp(1rem, 4vw, 1.25rem)',
    cursor: isSubmitting ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s ease',
    minWidth: '200px',
    maxWidth: '90%',
    position: 'relative',
    overflow: 'hidden',
    opacity: isSubmitting ? 0.7 : 1
  }}
>
  {isSubmitting ? 'Sending...' : 'Send Message'}
</GradientButton>
            {status && (
              <div style={{ 
                padding: '0.75rem', 
                borderRadius: '4px',
                backgroundColor: status.includes('✅') ? '#d4edda' : '#f8d7da',
                color: status.includes('✅') ? '#155724' : '#721c24',
                border: status.includes('✅') ? '1px solid #c3e6cb' : '1px solid #f5c6cb'
              }}>
                {status}
              </div>
            )}
          </form>
        )}
      </div>
    </>
  );
};

const inputStyle = {
  padding:'0.75rem', 
  fontSize:'1rem', 
  borderRadius:'4px', 
  border:'1px solid #ccc', 
  width:'100%',
  transition: 'opacity 0.2s ease'
};

const textareaStyle = {
  ...inputStyle,
  resize:'vertical'
};

export default Contact;